export default class Utilities {
    constructor() {
        this.matchesPolyfill();
    }

    matchesPolyfill() {
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;
        }
    }
}
